/**
* Togglebutton.
* Usage:
* <button toggle-button="item.isChosen"></button>
*
* Kun arvo on true, elementille lisätään myös 'is-active' classi.
* Muutenhan toiminta on periaatteessa sama kuin ng-click="someval = !someval".
*/
app.directive('toggleButton', ["$rootScope", function($rootScope) {
	
	return {
		restrict: 'A',
		link: function(scope, element, attrs) {
			var multiselect = attrs.multiselect !== undefined ? JSON.parse(attrs.multiselect) : true;

			scope.$watch(attrs.toggleButton, function(newVal, oldVal) {
				if (multiselect === false) {
					if (newVal) {
						$(element).addClass("is-active");
						$(element).siblings().removeClass("is-active");
					}
					else {
						$(element).removeClass("is-active");
					}
				}
				else {
					if(newVal) {
						$(element).addClass("is-active");
					}
					else {
						$(element).removeClass("is-active");	
					}
				}
			});

			$(element).on('click', function() {
				scope.$apply(function() {
					if(typeof(attrs.toggleAction) != 'undefined') {
						scope.$eval(attrs.toggleAction);
					}
					else {
						scope.$eval(attrs.toggleButton + "=" + !scope.$eval(attrs.toggleButton));
					}
				});
			});
		}
	};
}]);
	
